var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-chip',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.conversationTopic.name)+" ("+_vm._s(_vm.count)+")")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }